import Chart3 from "../Charts/Chart3";
import Chart4 from "../Charts/Chart4";
import Chart5 from "../Charts/Chart5";
import Chart6 from "../Charts/Chart6";




export default function SensorThree(props){
    
    return ( 
        <div className="flex flex-col my-5 ml-0 gap-5">
            <div className="lg:flex justify-center items-start mb-5">
                <Chart3 theme = {props.theme} title = 'GF Production Area '/>
            </div> 
            <Chart4 
                style = {{ width: "100%", height: "400%",border:"2px solid white"  }} 
                theme = {props.theme} 
                title = 'FF Production Area '/>
            <Chart5
                style = {{ width: "100%", height: "400%",border:"2px solid white"  }} 
                theme = {props.theme} 
                title = 'Compressor Area'/>
            <Chart6
                style = {{ width: "100%", height: "400%",border:"2px solid white"  }} 
                theme = {props.theme} 
                title = 'SF Validation'/> 
        </div>
    )
}